import { Avatar, Box, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Pagination, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import useCouponHistoryController from "./controller"
import { SELECT_BACKGROUND_COLOR, TABLE_HEADER_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors"
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated"
import SearchIcon from '@mui/icons-material/Search';
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { useTranslation } from "react-i18next";
import { CouponHistoryModel } from "../../models/couponHistory";
import { numberFormat } from "../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import { IMAGE_CUSTOMER } from "../../lib/endpoints/customer";
import moment from "moment";
import TableSearchNotFound from "../../components/tableSearchNotFound";
import SelectedBranchComponentVoid from "../../components/SelectedBranchVoid";


const CouponHistoryView = () => {
    const controller = useCouponHistoryController()
    const { t, i18n } = useTranslation("global");
    const TableHeaders: string[] = [t("coupon_page.No"), t("coupon_page.Profile"), t("coupon_page.Full name"), t("coupon_page.Phone"), t("coupon_page.Coupon Code"), t("coupon_page.Date of use")]

    return (
        <Box>
            {
                controller.loadingData ?
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadingAnimatedIcon />
                    </Box> :
                    <>
                        <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>{t("coupon_page.Coupon history")}</Typography>
                                <TextField value={controller.searchValue} onChange={controller.handleSearchValue} fullWidth sx={{ maxWidth: 250 }} placeholder={`${t('coupon_page.Search')}`}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        )
                                    }} size="small" />
                                <Box sx={{ width: 200 }}>
                                    {/* <FormControl fullWidth size="small">
                                        <InputLabel id="merchant-label-id" shrink={true}>{t("Branch")}</InputLabel>
                                        <Select
                                            labelId="merchant-label-id"
                                            id="merchant-id"
                                            label="All branch"
                                            value={controller.merchantValue}
                                            onChange={(e) => controller.handleSelectMerchant(e.target.value)}
                                            sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                        >
                                            {
                                                controller.merchantData?.map((branch) => (
                                                    <MenuItem key={branch.id} value={branch.id}>
                                                        {i18n.language === EN_ACCEPT_LANGUAGE ? branch?.nameEn : branch?.nameLa}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl> */}
                                    <SelectedBranchComponentVoid value={controller.merchantValue} onSelectMerchant={controller.handleSelectMerchant} merchantData={controller.merchantData}/>
                                </Box>
                                <TextField type="date" fullWidth
                                    value={controller.date}
                                    onChange={controller.handleChangeDate}
                                    sx={{
                                        maxWidth: 150, "& .MuiOutlinedInput-root": {
                                            "& > fieldset": {
                                                border: "none"
                                            }
                                        }
                                    }} size="small" label={t("coupon_page.Coupon date of use")} InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            backgroundColor: SELECT_BACKGROUND_COLOR,
                                            borderRadius: '8px'
                                        }
                                    }} InputLabelProps={{ shrink: true }} />
                            </Box>
                        </Box>
                        <Box mt={4}>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ background: TABLE_HEADER_BACKGROUND_COLOR }}>
                                        <TableRow>
                                            {
                                                TableHeaders.map((item: string, ind: number) => <TableCell sx={{ borderBottom: "none" }} key={ind}>{item}</TableCell>)
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            controller.rows.map((row: CouponHistoryModel, index: number) => {
                                                const { customer, couponCode, createdAt } = row
                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell align="left" sx={{ borderBottom: "none" }}>
                                                            {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1))}
                                                        </TableCell>
                                                        <TableCell sx={{ borderBottom: 'none' }}>
                                                            <Avatar
                                                                alt="Staff"
                                                                src={IMAGE_CUSTOMER + customer?.profile?.image?.url}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    objectFit: 'contain',
                                                                    borderRadius: 180,
                                                                    width: 50,
                                                                    height: 50,
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ borderBottom: "none" }}>
                                                            {
                                                                customer?.profile?.fullName
                                                            }
                                                        </TableCell>
                                                        <TableCell sx={{ borderBottom: "none" }}>
                                                            {
                                                                customer?.customer?.phone
                                                            }
                                                        </TableCell>
                                                        <TableCell sx={{ borderBottom: "none" }}>
                                                            {
                                                                couponCode
                                                            }
                                                        </TableCell>
                                                        <TableCell sx={{ borderBottom: "none" }}>
                                                            {moment(new Date(createdAt)).format('DD/MM/YYYY')}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                    {
                                        controller.isSearchNotFound && (
                                            <TableSearchNotFound searchValue={controller.searchValue} colSpan={TableHeaders.length} />
                                        )
                                    }
                                </Table>
                            </TableContainer>
                            <Divider sx={{ mt: 1, mb: 1 }} />
                            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                <Pagination onChange={controller.handleChangePage} page={controller.currentPage} count={controller.countPagination} color="primary" />
                            </Box>
                        </Box>
                    </>
            }
        </Box>
    )
}
export default CouponHistoryView